import React, { useState, useEffect } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import MuiAlert from '@mui/material/Alert';
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Paper,
  Grid,
  Alert,
  Snackbar,
  CircularProgress,
  Breadcrumbs,
  Link,
  Divider,
  Chip,
  IconButton,
  Tooltip,
  Avatar,
  Card,
  CardContent,
  CardHeader,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Badge,
  FormControlLabel,
  Switch,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
  Popover,
  ClickAwayListener
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ImageIcon from '@mui/icons-material/Image';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DeleteIcon from '@mui/icons-material/Delete';

const API_URL = process.env.REACT_APP_API_URL; 
function CreateTicket({ onClose = () => {} }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    summary: "",
    description: "",
    project: "",
    priority: "", // No default priority
    additional_users: "",
    comments: "",
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  // Get API URL from environment variables
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002';
  
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [isDragActive, setIsDragActive] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const [projectOptions] = useState([
    "Bi Migrator",
    "Samyama",
    "CSDLC",
    "Marketing",
    "DevOps",
    "VM-Reports",
    "foundation Service",
  ]);
  const [projectAnchorEl, setProjectAnchorEl] = useState(null);
  const [priorityAnchorEl, setPriorityAnchorEl] = useState(null);
  const isProjectMenuOpen = Boolean(projectAnchorEl);
  const isPriorityMenuOpen = Boolean(priorityAnchorEl);

  useEffect(() => {
    const email = localStorage.getItem('user_email');
    const token = localStorage.getItem('auth_token');
    
    if (!token) {
      navigate('/login');
      return;
    }
    
    if (email) {
      setUserEmail(email);
    }
    
    const storedToken = localStorage.getItem('auth_token');
    if (storedToken) {
      setToken(storedToken);
      // Extract user info from token
      const payload = parseJwt(storedToken);
      setUser({
        email: payload.email,
        name: payload.name,
        picture: payload.picture
      });
    } else {
      // Redirect to login if no token
      navigate('/login');
    }
  }, [navigate]);

  const parseJwt = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    } catch (e) {
      console.error("Error parsing JWT:", e);
      return {};
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleProjectClick = (event) => {
    setProjectAnchorEl(event.currentTarget);
  };

  const handleProjectClose = () => {
    setProjectAnchorEl(null);
  };

  const handleProjectSelect = (project) => {
    setFormData(prev => ({
      ...prev,
      project: project
    }));
    setProjectAnchorEl(null);
  };

  const handlePriorityClick = (event) => {
    setPriorityAnchorEl(event.currentTarget);
  };

  const handlePriorityClose = () => {
    setPriorityAnchorEl(null);
  };

  const handlePrioritySelect = (priority) => {
    setFormData(prev => ({
      ...prev,
      priority: priority
    }));
    setPriorityAnchorEl(null);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      setSelectedFiles(prevFiles => [...prevFiles, ...acceptedFiles]);
    },
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
    },
    maxSize: 10 * 1024 * 1024, // 10MB
    onDragEnter: () => setIsDragActive(true),
    onDragLeave: () => setIsDragActive(false)
  });

  const handleRemoveFile = (index) => {
    setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const email = localStorage.getItem('user_email');
      const token = localStorage.getItem('auth_token');
      
      if (!token) {
        setError('You must be logged in to create a ticket');
        setIsLoading(false);
        return;
      }

      const formDataToSend = new FormData();
      
      // Add form data
      Object.keys(formData).forEach(key => {
        formDataToSend.append(key, formData[key]);
      });
      
      // Add files
      selectedFiles.forEach(file => {
        formDataToSend.append('files', file);
      });

      const response = await axios.post(
        'https://fztfytovnyxxetzgjzxl.supabase.co/functions/v1/tickets/create',
        {
          ...formData  // just the normal text fields
          // Do NOT include files here
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (response.data && response.data.ticket_number) {
        // Reset form first
        const resetForm = () => {
          setFormData({
            title: "",
            summary: "",
            description: "",
            project: "",
            priority: "",
            additional_users: "",
            comments: "",
          });
          setSelectedFiles([]);
          setError('');
        };
        
        // Show success notification
        setSnackbar({
          open: true,
          message: `Ticket #${response.data.ticket_number} created successfully!`,
          severity: 'success',
        });
        
        // Reset the form
        resetForm();
        
        // Redirect to support dashboard after a delay
        setTimeout(() => {
          navigate('/support-dashboard');
        }, 2000);
      }
    } catch (err) {
      console.error('Error creating ticket:', err);
      // Set error in snackbar
      setSnackbar({
        open: true,
        message: 'Failed to create ticket. Please try again.',
        severity: 'error',
      });
      
      // Also set error in error state for form display
      if (err.response?.data?.error) {
        if (err.response.data.error.includes('Missing required fields')) {
          setError(`Please fill in all required fields: ${err.response.data.error.replace('Missing required fields: ', '')}`);
        } else {
          setError(err.response.data.error);
        }
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else if (err.message === 'Network Error') {
        setError('Unable to connect to the server. Please check your connection.');
      } else {
        setError('Failed to create ticket. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({...snackbar, open: false});
  };

  const handleCancel = () => {
    // Reset form data to initial state
    setFormData({
      title: "",
      summary: "",
      description: "",
      project: "",
      priority: "",
      additional_users: "",
      comments: "",
    });
    
    // Clear any selected files
    setSelectedFiles([]);
    
    // Call the onClose callback if provided
    onClose();
  };

  return (
    <Box sx={{ 
      maxWidth: '1440px',
      margin: '0 auto',
      padding: { xs: 2, md: 4 },
      backgroundColor: '#EEF5F6',
      minHeight: '100vh'
    }}>
      {!user ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
          <CircularProgress />
        </Box>
      ) : (
        <>
          {/* Header with Back Button and Breadcrumb */}
          <Box sx={{ 
            mb: 2, 
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%'
          }}>
            <Button
              component={RouterLink}
              to="/support-dashboard"
              sx={{
                color: '#4299D4',
                fontFamily: 'Proxima Nova',
                fontSize: '12px',
                textTransform: 'none',
                p: 0,
                pl: 20,  
                mt: -5.5,  // Adjusted from -1.5 to -2.5 to move up
                pt: 0.5,   // Added to fine-tune vertical alignment
                minWidth: 'auto',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                '&:hover': {
                  backgroundColor: 'transparent',
                  textDecoration: 'none'
                }
              }}
            >
              <span style={{ fontSize: '16px' }}>‹</span> Back
            </Button>
            <Breadcrumbs 
              separator={
                <span style={{ color: '#4299D4' }}> &gt; </span>
              } 
              aria-label="breadcrumb" 
              sx={{ 
                fontSize: '12px', 
                fontStyle: 'normal',
                fontWeight: 400,
                color: '#6D6D6D',
                marginRight: '150px',
                marginTop: '-40px',
                '& .MuiBreadcrumbs-ol': {
                  justifyContent: 'flex-end',
                  '& .MuiBreadcrumbs-separator': {
                    color: '#4299D4'
                  }
                }
              }}
            >
              <Link component={RouterLink} to="/" color="inherit" sx={{ color: '#4299D4', textDecoration: 'none', '&:hover': { textDecoration: 'none' } }}>
                Dashboard
              </Link>
              <Link component={RouterLink} to="/support-dashboard" color="inherit" sx={{ color: '#4299D4', textDecoration: 'none', '&:hover': { textDecoration: 'none' } }}>
                Support Management
              </Link>
              <Typography color="text.primary" sx={{ fontSize: '12px', color: '#6D6D6D' }}>Create Ticket</Typography>
            </Breadcrumbs>
          </Box>

          {/* Page Title */}
          <Box sx={{ paddingLeft: '5px', width: '982px', margin: '0 auto' }}>
            <Typography 
              variant="h1" 
              sx={{
                color: '#1674B4',
                fontFamily: 'Proxima Nova',
                fontSize: '30px',
                fontWeight: 500,
                mb: 1.5
              }}
            >
              Create Support Ticket
            </Typography>
            
            <Divider sx={{ mb: 1.5, borderColor: '#B1B1B1' }} />
            
            <Box sx={{ mb: 2 }}>
              <Typography 
                variant="body1" 
                sx={{ 
                  fontFamily: 'Proxima Nova',
                  fontSize: '14px',
                  fontWeight: 700,
                  lineHeight: 'normal',
                  color: '#333',
                  mb: 0.5
                }}
              >
                Please fill out the form below to create a new support ticket.
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  fontFamily: 'Proxima Nova',
                  fontSize: '14px',
                  color: '#6D6D6D',
                  lineHeight: '1',
                  mt: 0
                }}
              >
                Our team will respond as soon as possible.
              </Typography>
            </Box>
          </Box>
          
          <Paper 
            elevation={0} 
            sx={{ 
              display: 'flex',
              width: '982px',
              padding: { xs: '24px', md: '48px 201.655px 32px 201px' },
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '6px',
              backgroundColor: '#FFF',
              boxShadow: '2px 2px 2px 0px rgba(0, 0, 0, 0.25)',
              margin: '0 auto',
              mb: 4
            }}
          >
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <Grid container spacing={3}>
                {/* Title */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                    <span style={{ color: '#d32f2f' }}></span>
                  </Typography>
                  <TextField
                    fullWidth
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    placeholder="Title *"
                    size="small"
                    InputLabelProps={{
                      style: { color: '#6D6D6D' },
                    }}
                    InputProps={{
                      style: { color: formData.title ? '#333' : '#6D6D6D' },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        width: '579.345px',
                        height: '40px',
                        '& fieldset': {
                          border: '1px solid #D9D9D9',
                          borderRadius: '4px',
                          boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.25)',
                        },
                        '&:hover fieldset': {
                          borderColor: '#4299D4',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#4299D4',
                        },
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '6px 12px',
                        '&::placeholder': {
                          color: '#6D6D6D',
                          opacity: 1,
                        },
                      },
                    }}
                  />
                </Grid>
                
                {/* Summary */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                     <span style={{ color: '#d32f2f' }}></span>
                  </Typography>
                  <TextField
                    fullWidth
                    name="summary"
                    value={formData.summary}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    placeholder="Summary *"
                    size="small"
                    multiline
                    rows={2}
                    InputLabelProps={{
                      style: { color: '#6D6D6D' },
                    }}
                    InputProps={{
                      style: { color: formData.summary ? '#333' : '#6D6D6D' },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        width: '579.345px',
                        minHeight: '40px',
                        '& fieldset': {
                          border: '1px solid #D9D9D9',
                          borderRadius: '4px',
                          boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.25)',
                        },
                        '&:hover fieldset': {
                          borderColor: '#4299D4',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#4299D4',
                        },
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '6px 12px px 0',
                        height: '100%',
                        alignItems: 'flex-start',
                        '&::placeholder': {
                          color: '#6D6D6D',
                          opacity: 1,
                          paddingLeft: '0',
                        },
                      },
                      '& .MuiOutlinedInput-multiline': {
                        padding: '0',
                      },
                    }}
                  />
                </Grid>
                
                {/* Description */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                    <span style={{ color: '#d32f2f' }}></span>
                  </Typography>
                  <TextField
                    fullWidth
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    required
                    multiline
                    rows={4}
                    variant="outlined"
                    placeholder="Description *"
                    size="small"
                    InputLabelProps={{
                      style: { color: '#6D6D6D' },
                    }}
                    InputProps={{
                      style: { color: formData.description ? '#333' : '#6D6D6D' },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        width: '579px',
                        minHeight: '151px',
                        '& fieldset': {
                          border: '1px solid #D9D9D9',
                          borderRadius: '4px',
                          boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.25)',
                        },
                        '&:hover fieldset': {
                          borderColor: '#4299D4',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#4299D4',
                        },
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '6px 12px 53px 0',
                        height: '100%',
                        alignItems: 'flex-start',
                        '&::placeholder': {
                          color: '#6D6D6D',
                          opacity: 1,
                          paddingLeft: '0',
                        },
                      },
                      '& .MuiOutlinedInput-multiline': {
                        padding: '0',
                      },
                    }}
                  />
                </Grid>

                {/* Projects Dropdown */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                    <span style={{ color: '#d32f2f' }}></span>
                  </Typography>
                  <Box sx={{ position: 'relative', width: '579.345px' }}>
                    <TextField
                      fullWidth
                      name="project"
                      value={formData.project}
                      onClick={handleProjectClick}
                      readOnly
                      required
                      variant="outlined"
                      placeholder="Projects *"
                      size="small"
                      InputLabelProps={{
                        style: { color: '#6D6D6D' },
                      }}
                      InputProps={{
                        style: { color: formData.project ? '#333' : '#6D6D6D' },
                        readOnly: true,
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          width: '100%',
                          height: '40px',
                          paddingRight: '40px',
                          cursor: 'pointer',
                          '& fieldset': {
                            border: '1px solid #D9D9D9',
                            borderRadius: '4px',
                            boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.25)',
                          },
                          '&:hover fieldset': {
                            borderColor: '#4299D4',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#4299D4',
                          },
                        },
                        '& .MuiOutlinedInput-input': {
                          padding: '6px 12px',
                          cursor: 'pointer',
                          '&::placeholder': {
                            color: '#6D6D6D',
                            opacity: 1,
                          },
                        },
                      }}
                    />
                    <Box 
                      sx={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'none',
                        color: 'rgba(0, 0, 0, 0.54)',
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </Box>
                  </Box>
                  
                  <Popover
                    open={isProjectMenuOpen}
                    anchorEl={projectAnchorEl}
                    onClose={handleProjectClose}
                    disableScrollLock={true}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        width: '579.345px',
                        maxHeight: '300px',
                        overflowY: 'auto',
                        borderRadius: '4px',
                        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.15)',
                        marginTop: '4px',
                        '& .MuiMenuItem-root': {
                          padding: '8px 16px',
                          '&:hover': {
                            backgroundColor: 'rgba(66, 153, 212, 0.08)',
                          }
                        }
                      }
                    }}
                  >
                    {projectOptions.map((project, index) => (
                      <MenuItem 
                        key={index} 
                        onClick={() => handleProjectSelect(project)}
                        sx={{
                          '&:hover': {
                            backgroundColor: 'rgba(66, 153, 212, 0.08)',
                          },
                          '&.Mui-selected': {
                            backgroundColor: 'rgba(66, 153, 212, 0.12)',
                            '&:hover': {
                              backgroundColor: 'rgba(66, 153, 212, 0.16)',
                            }
                          }
                        }}
                        selected={formData.project === project}
                      >
                        {project}
                      </MenuItem>
                    ))}
                  </Popover>
                </Grid>
                
                
                
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                    <span style={{ color: '#d32f2f' }}></span>
                  </Typography>
                  <Box sx={{ position: 'relative', width: '579.345px' }}>
                    <TextField
                      fullWidth
                      name="priority"
                      value={formData.priority}
                      onClick={handlePriorityClick}
                      readOnly
                      required
                      variant="outlined"
                      placeholder="Priority"
                      size="small"
                      InputLabelProps={{
                        style: { color: '#6D6D6D' },
                      }}
                      InputProps={{
                        style: { color: formData.priority ? '#333' : '#6D6D6D' },
                        readOnly: true,
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          width: '100%',
                          height: '40px',
                          paddingRight: '40px',
                          cursor: 'pointer',
                          '& fieldset': {
                            border: '1px solid #D9D9D9',
                            borderRadius: '4px',
                            boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.25)',
                          },
                          '&:hover fieldset': {
                            borderColor: '#4299D4',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#4299D4',
                          },
                        },
                        '& .MuiOutlinedInput-input': {
                          padding: '6px 12px',
                          cursor: 'pointer',
                          '&::placeholder': {
                            color: '#6D6D6D',
                            opacity: 1,
                          },
                        },
                      }}
                    />
                    <Box 
                      sx={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'none',
                        color: 'rgba(0, 0, 0, 0.54)',
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </Box>
                  </Box>
                  
                  <Popover
                    open={isPriorityMenuOpen}
                    anchorEl={priorityAnchorEl}
                    onClose={handlePriorityClose}
                    disableScrollLock={true}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        width: '579.345px',
                        maxHeight: '300px',
                        overflowY: 'auto',
                        borderRadius: '4px',
                        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.15)',
                        marginTop: '4px',
                        '& .MuiMenuItem-root': {
                          padding: '8px 16px',
                          '&:hover': {
                            backgroundColor: 'rgba(66, 153, 212, 0.08)',
                          }
                        }
                      }
                    }}
                  >
                    {['Low', 'Medium', 'High', 'Critical'].map((priority, index) => {
                      const colors = {
                        'Low': '#4CAF50',
                        'Medium': '#FFC107',
                        'High': '#FF9800',
                        'Critical': '#F44336'
                      };
                      
                      return (
                        <MenuItem 
                          key={index} 
                          onClick={() => handlePrioritySelect(priority)}
                          sx={{
                            '&.Mui-selected': {
                              backgroundColor: 'rgba(66, 153, 212, 0.12)'
                            }
                          }}
                          selected={formData.priority === priority}
                        >
                          {priority}
                        </MenuItem>
                      );
                    })}
                  </Popover>
                </Grid>
                
                {/* Additional Users */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                    <span style={{ color: '#d32f2f' }}></span>
                  </Typography>
                  <TextField
                    fullWidth
                    name="additional_users"
                    value={formData.additional_users}
                    onChange={handleChange}
                    placeholder="Additional Users (comma separated emails)"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      style: { color: '#6D6D6D' },
                    }}
                    InputProps={{
                      style: { color: formData.additional_users ? '#333' : '#6D6D6D' },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        width: '579.345px',
                        height: '40px',
                        '& fieldset': {
                          border: '1px solid #D9D9D9',
                          borderRadius: '4px',
                          boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.25)',
                        },
                        '&:hover fieldset': {
                          borderColor: '#4299D4',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#4299D4',
                        },
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '6px 12px',
                        '&::placeholder': {
                          color: '#6D6D6D',
                          opacity: 1,
                        },
                      },
                    }}
                  />
                </Grid>
                
                {/* Comments */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                    <span style={{ color: '#d32f2f' }}></span>
                  </Typography>
                  <TextField
                    fullWidth
                    name="comments"
                    value={formData.comments}
                    onChange={handleChange}
                    multiline
                    rows={4}
                    variant="outlined"
                    placeholder="Comments"
                    size="small"
                    InputLabelProps={{
                      style: { color: '#6D6D6D' },
                    }}
                    InputProps={{
                      style: { color: formData.comments ? '#333' : '#6D6D6D' },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        width: '579px',
                        minHeight: '151px',
                        '& fieldset': {
                          border: '1px solid #D9D9D9',
                          borderRadius: '4px',
                          boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.25)',
                        },
                        '&:hover fieldset': {
                          borderColor: '#4299D4',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#4299D4',
                        },
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '6px 12px 53px 0',
                        height: '100%',
                        alignItems: 'flex-start',
                        '&::placeholder': {
                          color: '#6D6D6D',
                          opacity: 1,
                          paddingLeft: '0',
                        },
                      },
                      '& .MuiOutlinedInput-multiline': {
                        padding: '0',
                      },
                    }}
                  />
                </Grid>
                
                {/* File Upload */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                    <span style={{ color: '#d32f2f' }}></span>
                  </Typography>
                  <Box
                    {...getRootProps()}
                    sx={{
                      width: '579px',
                      height: '71px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      border: '1px dashed #D9D9D9',
                      borderRadius: '4px',
                      backgroundColor: '#FFF',
                      boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.25)',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      ...(isDragActive && {
                        borderColor: '#4299D4',
                        backgroundColor: 'rgba(66, 153, 212, 0.08)',
                        '& .upload-icon': {
                          color: '#1976D2',
                        }
                      })
                    }}
                  >
                    <input {...getInputProps()} />
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <CloudUploadIcon 
                        className="upload-icon"
                        sx={{ 
                          width: '30px',
                          height: '30px',
                          flexShrink: 0,
                          aspectRatio: '1/1',
                          color: '#4299D4',
                          mb: 1
                        }} 
                      />
                      <Typography variant="body2" sx={{ 
                        color: '#6D6D6D',
                        fontFamily: '"Proxima Nova"',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: 'normal'
                      }}>
                        <span style={{ color: '#6D6D6D' }}>Drag & Drop Files Here or click to select files</span>
                      </Typography>
                    </Box>
                  </Box>
                  
                  {selectedFiles.length > 0 && (
                    <Box sx={{ mt: 3, mb: 2 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, color: '#333', fontWeight: 600 }}>
                        Selected Files ({selectedFiles.length})
                      </Typography>
                      <Box sx={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #E0E0E0', borderRadius: '4px' }}>
                        {selectedFiles.map((file, index) => (
                          <Box 
                            key={index}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              p: 1.5,
                              borderBottom: index < selectedFiles.length - 1 ? '1px solid #F5F5F5' : 'none',
                              '&:hover': {
                                backgroundColor: '#F5F5F5',
                              },
                            }}
                          >
                            {file.type.startsWith('image/') ? (
                              <ImageIcon sx={{ color: '#757575', mr: 1.5, fontSize: '1.25rem' }} />
                            ) : (
                              <InsertDriveFileIcon sx={{ color: '#757575', mr: 1.5, fontSize: '1.25rem' }} />
                            )}
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography 
                                noWrap 
                                sx={{ 
                                  fontWeight: 500, 
                                  color: '#212121',
                                  fontSize: '0.875rem',
                                }}
                              >
                                {file.name}
                              </Typography>
                              <Typography 
                                variant="caption" 
                                sx={{ 
                                  color: '#757575',
                                  fontSize: '0.75rem',
                                }}
                              >
                                {(file.size / 1024 / 1024).toFixed(2)} MB
                              </Typography>
                            </Box>
                            <Tooltip title="Remove file">
                              <IconButton 
                                edge="end" 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveFile(index);
                                }}
                                size="small"
                                sx={{ color: '#757575', '&:hover': { color: '#D32F2F' } }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  )}
                </Grid>
                
                {/* Buttons */}
                <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                  <Button
                    type="button"
                    variant="outlined"
                    onClick={handleCancel}
                    disabled={isLoading}
                    sx={{
                      display: 'inline-flex',
                      padding: '8px 16px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '4px',
                      border: '1px solid #D9D9D9',
                      color: '#6D6D6D',
                      backgroundColor: '#FFF',
                      textTransform: 'none',
                      fontSize: '14px',
                      fontWeight: 400,
                      boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.08)',
                      '&:hover': {
                        backgroundColor: '#F5F5F5',
                        borderColor: '#D9D9D9',
                      },
                      '&.Mui-disabled': {
                        backgroundColor: '#F5F5F5',
                        color: '#BDBDBD',
                      },
                    }}
                  >
                    CANCEL
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isLoading}
                    startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                    sx={{
                      display: 'inline-flex',
                      padding: '8px 16px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '8px',
                      borderRadius: '4px',
                      backgroundColor: '#2DB9A8',
                      color: 'white',
                      textTransform: 'none',
                      fontSize: '14px',
                      fontWeight: 500,
                      boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.08)',
                      '&:hover': {
                        backgroundColor: '#26A897',
                        boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.12)',
                      },
                      '&.Mui-disabled': {
                        backgroundColor: '#BDBDBD',
                        color: '#9E9E9E',
                      },
                    }}
                  >
                    {isLoading ? 'Creating Ticket...' : 'SUBMIT TICKET'}
                  </Button>
                </Grid>
                
                {error && (
                  <Grid item xs={12}>
                    <Alert severity="error">{error}</Alert>
                  </Grid>
                )}
              </Grid>
            </form>
          </Paper>
          
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            sx={{
              '& .MuiPaper-root': {
                backgroundColor: snackbar.severity === 'success' ? '#4caf50' : undefined,
                color: 'white',
                '& .MuiAlert-icon': {
                  color: 'white',
                },
                '& .MuiAlert-message': {
                  color: 'white',
                }
              },
              '& .MuiSnackbarContent-root': {
                backgroundColor: snackbar.severity === 'success' ? '#4caf50' : undefined,
              }
            }}
          >
            <Alert 
              onClose={handleCloseSnackbar} 
              severity={snackbar.severity}
              sx={{ 
                width: '100%',
                backgroundColor: 'transparent',
                color: 'white',
                '& .MuiAlert-message': {
                  color: 'white',
                }
              }}
              elevation={0}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
        </>
      )}
    </Box>
  );
};

export default CreateTicket;